import {properties} from './properties';

function _window(): any {
    return window;
}

declare var AB: any;

const storeId = '9999';

export const environment = {
    production: false,
    clientBannerHeader: properties.clientBannerHeader,
    oktaRedirectUri: properties.oktaRedirectUri,
    oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
    oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
    erumsRedirectCookieName: properties.erumsRedirectCookieName,
    tooltips: properties.tooltips,
    bannerConfiguration: properties.bannerConfiguration,
    PromoTypeDescription: properties.PromoTypeDescription,
    lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
    authApi: '/bin/safeway/unified/userinfo?banner={banner}',
    SSO_URL: '/bin/safeway/sso',
    SIGN_IN_URL: '/account/sign-in.html',
    RE_SIGN_IN_URL: '/account/re-sign-in.html',
    LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',
    Left_NAV_API_V2: '/content/experience-fragments/www/{banner}/en/generic_content/uca-navigation-v2/uca-navigation-v2/jcr:content/root/responsivegrid/uca_navigation-v2.model.json',
    qa1: {
        currentEnv: 'qa1',
        aemFreshPassBenefitsJSONURL: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.caas.json',
        freshpassLPMaster_Jewelosco_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.caas.json',
        freshpassLPMaster_Acme_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.caas.json',
        getSubscriptionApiConfig: {
            url: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint,
        },
        getUserEnrollmentDetails: {
            url: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/getUserEnrollmentDetails/{uuid}/{gid}',
        },
        getPlansApiConfig: {
            url: "/abs/qapub/erums/subscriptionservice/api/v1/subscription/plans",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaServiceRestEndpoint,
        },
        changePlanApiConfig: {
            url: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/create/{gid}',
        },
        getTendersApiConfig: {
            url: "/abs/qa2int/ospg/tokenvault/wallet/customers/{uuid}/payment-methods?paymentMethodContext=FRESH_PASS&pageViewContext=DEFAULT_VIEW",
            // url: _window().AB.creditCardInfoTokenvaultPath.replace('{customerId}', _window().AB.userInfo.UUID) + '?storeId=9999',
        },

        getUserProfileInfo: {
            url: "/abs/qapub/cnc/ucaservice/api/uca/customers/{gid}/profile"
            // url: _window().AB.COMMON.ucaAPIPathWithCustomerId(_window().AB.userProfilePath),
        },

        getCancelReasonsApiConfig: {
            url: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/admin/cancel/reasons',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaCancelReasonsApiEndpoint,
        },
        getCancelReasonsApiConfigV2: {
          url: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/cancel/reasons'
        },
        cancelSubscriptionPlanApiConfig: {
            url: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/cancel/{gid}'
            // url: (_window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint.replace('{gid}', _window().AB.userInfo.gid)).replace('get', 'cancel'),
        },

        getTermsInfoApi: {
            url: "/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/terms/gid",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaGetUserTermsEndpoint + '/'+ _window().AB.userInfo.customerId,
        },
        getOffersGalleryFilterApi: {
            url: '/abs/qapub/dce/offergallery/offers/filter',
        },
        getPartnerOffersAllocationApi:{
            url:'/abs/qaint/ocsp/partnerofferservice/partnerOffers/allocation'
        },
        paymentIframeURL: 'https://token-qa1.albertsons.com/api/v1/payment/',
        reinstateAPI: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/reinstate/',
        snapEligibilityEasySteps: '/content/experience-fragments/www/landing_pages/freshpass/fresh-pass-snap-eligibility/master.content.html',
        preChurnCancelBenefitsTiles: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/prechurn-benefits-tiles.caas.json',
        freshpassLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.content.html',
        freshpassLPMaster_Jewelosco: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.content.html',
        freshpassLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.content.html',
        belowTilesLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/master.content.html',
        belowTilesLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/below-tiles-jo-acme.content.html',
        belowTilesLpMaster_Jo: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/jo-below-tiles.content.html',
        freshpassContentFAQ: '/content/experience-fragments/www/landing_pages/delivery-subscription-faqs/delivery-subscription-faqs.content.html',
        freshpassTerms: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/delivery-subscription-terms-and-conditions.content.html',
        freshpassTerms_Acme: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/acme-terms-and-conditions.content.html',
        freshpassTerms_JO: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/jo-terms-and-conditions.content.html',
        createAccountFragment: '/content/experience-fragments/www/{banner}/en/generic_content/account/create-account.html',
        signInFragement: '/content/experience-fragments/www/{banner}/en/generic_content/account/sign-in.html',
        dsEnabledFlag: "true",
        dsPreferenceEndPoint: "/abs/qapub/cnc/ucaservice/api/uca/customers/{customerId}/preferences/deliverySubscriptions",
        dsManageUrl: "/delivery-subscription/manage-delivery-subscription.html",
        dsUserApiEndpoint: "/abs/qa1pub/subscription/api/user/{gid}",
        dsCancelReasonsApiEndpoint: "/abs/qa1pub/subscription/api/admin/cancel/reasons",
        dsUserShopOrderCountApiEndpoint: "/abs/qa1pub/web/ecom/api/subscription/user/ordercount",
        dsPaymentmethodDomain: "https://token-qa1.albertsons.com",
        dsJavaBasePath: "/abs/qapub/erums/subscriptionservice",
        dsJavaEnabledFlag: "true",
        dsJavaServiceRestEndpoint: "/api/v1/subscription/plans",
        dsJavaUserApiEndpoint: "/api/v1/subscription/user/get/{gid}",
        dsJavaCancelReasonsApiEndpoint: "/api/v1/subscription/admin/cancel/reasons",
        dsJavaUserEnrollmentDetails: "/api/v1/subscription/user/getUserEnrollmentDetails",
        dsJavaSubscriptionReinstate: "/api/v1/subscription/user/reinstate/{gid}",
        dsJavaSubscriptionCreate: "/api/v1/subscription/user/create/{gid}",
        dsJavaGetUserTermsEndpoint: "/api/v1/subscription/user/terms/gid",
        dsConfirmationPagePath: "/freshpass/manage/confirmation",
        getPartnerDiscount: {
            url: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/anonymous/discountplan',
        },
        loyaltyPromosURL: "/bin/safeway/loyalty/promos",
        subscriptionHeaders: {
            deliverySubHttpJavaOptions: {
                'Accept': 'application/vnd.safeway.v2+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'dd394e5d0f9149e2bd9898dcfc0c5d6d',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
            },
            deliverySubHttpJavaOptionsV3: {
              'Accept': 'application/vnd.safeway.v3+json',
              'banner': '{banner}',
              'ocp-apim-subscription-key': 'dd394e5d0f9149e2bd9898dcfc0c5d6d',
              'Content-Type': 'application/json',
              'x-swy-client-id': 'web-portal',
              'x-swy-client-name': 'WEB-PORTAL',
              'x-swy-banner': '{banner}',
              'cache-control': 'no-cache',
            },
            deliverySubHttpJavaOptionsV4: {
                'Accept': 'application/vnd.safeway.v4+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'dd394e5d0f9149e2bd9898dcfc0c5d6d',
                'Content-Type': 'application/json',
                'cache-control': 'no-cache',
                'x-swy-client-name': 'web-portal',
                'x-swy-banner': '{banner}',
            },
            ucaHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'X-SWY_BANNER': '{banner}',
                'Ocp-Apim-Subscription-Key': 'b63410670d33422186409d4ad55c9030',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            ucaHttpOptionsv4: {
              'Accept': 'application/vnd.safeway.v4+json',
              'x-swy-banner': '{banner}',
              'x-swy-client-name': 'web-portal',
              'Ocp-Apim-Subscription-Key': 'b63410670d33422186409d4ad55c9030',
            },
            paymentOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': 'f584bc9c75d34af2bb29a8e9e04eddfa',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-name': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            reinstateOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'X-SWY_BANNER': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': 'dd394e5d0f9149e2bd9898dcfc0c5d6d',
            }
        },
        offerGalleryFilterApiHeaders: {
            'Accept': 'application/json',
            'x-swy-client-id': 'web-portal',
            'Content-Type': 'application/json',
            'X-SWY_API_KEY': 'emjou',
            'x-swy_banner': '{banner}',
            'Cache-Control': 'no-cache',
            'X-SWY_VERSION': '3.0',
            'X-SWY-APPLICATION-TYPE': 'web',
            'emju-ocsp-b4u-qa': 'ac33a973b8c44e108e426ecf1d1a2a99'
        },
        partnerOffersAllocationApiHeaders: {
            'Content-Type': 'application/vnd.safeway.v1+json',
            'Cache-Control': 'no-cache',
            'X-SWY_VERSION': '3.0',
            'X-SWY-APPLICATION-TYPE': 'web',
            'banner': '{banner}',
            'Ocp-Apim-Subscription-Key': '4407e126d1de4524880a1b0505093464',
            'x-swy-client-name': 'web-portal',
            'x-swy-banner': '{banner}',
         },
        freshpassFAQ: '/delivery-subscription/dsfaqs.html?isDSManage=true'
    },
    qa2: {
        currentEnv: 'qa2',
        aemFreshPassBenefitsJSONURL: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.caas.json',
        freshpassLPMaster_Jewelosco_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.caas.json',
        freshpassLPMaster_Acme_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.caas.json',
        getSubscriptionApiConfig: {
            url: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint,
        },
        getUserEnrollmentDetails: {
            url: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/getUserEnrollmentDetails/{uuid}/{gid}',
        },
        getPlansApiConfig: {
            url: "/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/plans",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaServiceRestEndpoint,
        },
        changePlanApiConfig: {
            url: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/create/{gid}',
        },
        getTendersApiConfig: {
            url: "/abs/qaint/ospg/tokenvault/wallet/customers/{uuid}/payment-methods?paymentMethodContext=FRESH_PASS&pageViewContext=DEFAULT_VIEW",
            // url: _window().AB.creditCardInfoTokenvaultPath.replace('{customerId}', _window().AB.userInfo.UUID) + '?storeId=9999',
        },

        getUserProfileInfo: {
            url: "/abs/acceptancepub/cnc/ucaservice/api/uca/customers/{gid}/profile"
            // url: _window().AB.COMMON.ucaAPIPathWithCustomerId(_window().AB.userProfilePath),
        },

        getCancelReasonsApiConfig: {
            url: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/admin/cancel/reasons',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaCancelReasonsApiEndpoint,
        },
        getCancelReasonsApiConfigV2: {
          url: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/cancel/reasons'
        },
        cancelSubscriptionPlanApiConfig: {
            url: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/cancel/{gid}'
            // url: (_window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint.replace('{gid}', _window().AB.userInfo.gid)).replace('get', 'cancel'),
        },

        getTermsInfoApi: {
            url: "/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/terms/gid",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaGetUserTermsEndpoint + '/'+ _window().AB.userInfo.customerId,
        },
        getPartnerDiscount: {
            url: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/anonymous/discountplan',
        },
        loyaltyPromosURL: "/bin/safeway/loyalty/promos",
        getOffersGalleryFilterApi: {
            url: '/abs/acceptancepub/dce/offergallery/offers/filter',
        },
        getPartnerOffersAllocationApi:{
            url:'/abs/acceptancepub/ocsp/partnerofferservice/partnerOffers/allocation'
        },
        paymentIframeURL: 'https://token-acceptance.albertsons.com/api/v1/payment/',
        reinstateAPI: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/reinstate/',
        snapEligibilityEasySteps: '/content/experience-fragments/www/landing_pages/freshpass/fresh-pass-snap-eligibility/master.content.html',
        preChurnCancelBenefitsTiles: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/prechurn-benefits-tiles.caas.json',
        freshpassLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.content.html',
        freshpassLPMaster_Jewelosco: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.content.html',
        freshpassLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.content.html',
        belowTilesLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/master.content.html',
        belowTilesLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/below-tiles-jo-acme.content.html',
        belowTilesLpMaster_Jo: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/jo-below-tiles.content.html',
        freshpassContentFAQ: '/content/experience-fragments/www/landing_pages/delivery-subscription-faqs/delivery-subscription-faqs.content.html',
        freshpassTerms: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/delivery-subscription-terms-and-conditions.content.html',
        freshpassTerms_Acme: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/acme-terms-and-conditions.content.html',
        freshpassTerms_JO: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/jo-terms-and-conditions.content.html',
        createAccountFragment: '/content/experience-fragments/www/{banner}/en/generic_content/account/create-account.html',
        signInFragement: '/content/experience-fragments/www/{banner}/en/generic_content/account/sign-in.html',
        dsEnabledFlag: "true",
        dsPreferenceEndPoint: "/abs/acceptancepub/cnc/ucaservice/api/uca/customers/{customerId}/preferences/deliverySubscriptions",
        dsManageUrl: "/delivery-subscription/manage-delivery-subscription.html",
        dsUserApiEndpoint: "/abs/acceptancepub/subscription/api/user/{gid}",
        dsCancelReasonsApiEndpoint: "/abs/acceptancepub/subscription/api/admin/cancel/reasons",
        dsUserShopOrderCountApiEndpoint: "/abs/acceptancepub/web/ecom/api/subscription/user/ordercount",
        dsPaymentmethodDomain: "https://token-qa1.albertsons.com",
        dsJavaBasePath: "/abs/acceptancepub/erums/subscriptionservice",
        dsJavaEnabledFlag: "true",
        dsJavaServiceRestEndpoint: "/api/v1/subscription/plans",
        dsJavaUserApiEndpoint: "/api/v1/subscription/user/get/{gid}",
        dsJavaCancelReasonsApiEndpoint: "/api/v1/subscription/admin/cancel/reasons",
        dsJavaUserEnrollmentDetails: "/api/v1/subscription/user/getUserEnrollmentDetails",
        dsJavaSubscriptionReinstate: "/api/v1/subscription/user/reinstate/{gid}",
        dsJavaSubscriptionCreate: "/api/v1/subscription/user/create/{gid}",
        dsJavaGetUserTermsEndpoint: "/api/v1/subscription/user/terms/gid",
        dsConfirmationPagePath: "/freshpass/manage/confirmation",
        subscriptionHeaders: {
            deliverySubHttpJavaOptions: {
                'Accept': 'application/vnd.safeway.v2+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '002a0b250eae4523b5b8ef483e79f209',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache'
            },
            deliverySubHttpJavaOptionsV3: {
              'Accept': 'application/vnd.safeway.v3+json',
              'banner': '{banner}',
              'ocp-apim-subscription-key': '002a0b250eae4523b5b8ef483e79f209',
              'Content-Type': 'application/json',
              'x-swy-client-id': 'web-portal',
              'x-swy-client-name': 'WEB-PORTAL',
              'x-swy-banner': '{banner}',
              'cache-control': 'no-cache',
            },
            deliverySubHttpJavaOptionsV4: {
                'Accept': 'application/vnd.safeway.v4+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '002a0b250eae4523b5b8ef483e79f209',
                'Content-Type': 'application/json',
                'cache-control': 'no-cache',
                'x-swy-client-name': 'web-portal',
                'x-swy-banner': '{banner}',
            },
            ucaHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'X-SWY_BANNER': '{banner}',
                'Ocp-Apim-Subscription-Key': 'd8c6d7783b604f618dd446e7c39c7c08',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            ucaHttpOptionsv4: {
              'Accept': 'application/vnd.safeway.v4+json',
              'x-swy-banner': '{banner}',
              'x-swy-client-name': 'web-portal',
              'Ocp-Apim-Subscription-Key': 'd8c6d7783b604f618dd446e7c39c7c08',
            },
            paymentOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '86a8843aebbe4739af1d84a743752fe1',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-name': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            reinstateOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'X-SWY_BANNER': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': '002a0b250eae4523b5b8ef483e79f209',
            }
        },
        offerGalleryFilterApiHeaders: {
            'Accept': 'application/json',
            'x-swy-client-id': 'web-portal',
            'Content-Type': 'application/json',
            'X-SWY_API_KEY': 'emjou',
            'x-swy_banner': '{banner}',
            'Cache-Control': 'no-cache',
            'X-SWY_VERSION': '3.0',
            'X-SWY-APPLICATION-TYPE': 'web',
            'emju-ocsp-b4u-acceptance': '9533fdb962494964aa8464c07ae37da6'
        },
        partnerOffersAllocationApiHeaders: {
            'Content-Type': 'application/vnd.safeway.v1+json',
            'Cache-Control': 'no-cache',
            'X-SWY_VERSION': '3.0',
            'X-SWY-APPLICATION-TYPE': 'web',
            'banner': '{banner}',
            'Ocp-Apim-Subscription-Key': '',
            'x-swy-client-name': 'web-portal',
            'x-swy-banner': '{banner}',
         },
        freshpassFAQ: '/delivery-subscription/dsfaqs.html?isDSManage=true'
    },
    qa3: {
        currentEnv: 'qa3',
        aemFreshPassBenefitsJSONURL: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.caas.json',
        freshpassLPMaster_Jewelosco_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.caas.json',
        freshpassLPMaster_Acme_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.caas.json',
        getSubscriptionApiConfig: {
            url: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint,
        },
        getUserEnrollmentDetails: {
            url: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/getUserEnrollmentDetails/{uuid}/{gid}',
        },
        getPlansApiConfig: {
            url: "/abs/perfpub/erums/subscriptionservice/api/v1/subscription/plans",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaServiceRestEndpoint,
        },
        changePlanApiConfig: {
            url: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/create/{gid}',
        },
        getTendersApiConfig: {
            url: "/abs/perfint/ospg/tokenvault/wallet/customers/{uuid}/payment-methods?paymentMethodContext=FRESH_PASS&pageViewContext=DEFAULT_VIEW",
            // url: _window().AB.creditCardInfoTokenvaultPath.replace('{customerId}', _window().AB.userInfo.UUID) + '?storeId=9999',
        },

        getUserProfileInfo: {
            url: "/abs/perfpub/cnc/ucaservice/api/uca/customers/{gid}/profile"
            // url: _window().AB.COMMON.ucaAPIPathWithCustomerId(_window().AB.userProfilePath),
        },

        getCancelReasonsApiConfig: {
            url: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/admin/cancel/reasons',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaCancelReasonsApiEndpoint,
        },
        getCancelReasonsApiConfigV2: {
          url: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/cancel/reasons'
        },
        cancelSubscriptionPlanApiConfig: {
            url: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/cancel/{gid}'
            // url: (_window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint.replace('{gid}', _window().AB.userInfo.gid)).replace('get', 'cancel'),
        },

        getTermsInfoApi: {
            url: "/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/terms/gid",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaGetUserTermsEndpoint + '/'+ _window().AB.userInfo.customerId,
        },
        getPartnerDiscount: {
            url: 'abs/perfpub/erums/subscriptionservice/api/v1/subscription/anonymous/discountplan',
        },
        loyaltyPromosURL: "/bin/safeway/loyalty/promos",
        getOffersGalleryFilterApi: {
            url: '/abs/perfpub/dce/offergallery/offers/filter',
        },
        getPartnerOffersAllocationApi:{
            url:'/abs/perfpub/ocsp/partnerofferservice/partnerOffers/allocation'
        },
        paymentIframeURL: 'https://token-perf.albertsons.com/api/v1/payment/',
        reinstateAPI: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/reinstate/',
        snapEligibilityEasySteps: '/content/experience-fragments/www/landing_pages/freshpass/fresh-pass-snap-eligibility/master.content.html',
        preChurnCancelBenefitsTiles: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/prechurn-benefits-tiles.caas.json',
        freshpassLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.content.html',
        freshpassLPMaster_Jewelosco: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.content.html',
        freshpassLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.content.html',
        belowTilesLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/master.content.html',
        belowTilesLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/below-tiles-jo-acme.content.html',
        belowTilesLpMaster_Jo: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/jo-below-tiles.content.html',
        freshpassContentFAQ: '/content/experience-fragments/www/landing_pages/delivery-subscription-faqs/delivery-subscription-faqs.content.html',
        freshpassTerms: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/delivery-subscription-terms-and-conditions.content.html',
        freshpassTerms_Acme: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/acme-terms-and-conditions.content.html',
        freshpassTerms_JO: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/jo-terms-and-conditions.content.html',
        createAccountFragment: '/content/experience-fragments/www/{banner}/en/generic_content/account/create-account.html',
        signInFragement: '/content/experience-fragments/www/{banner}/en/generic_content/account/sign-in.html',
        dsEnabledFlag: "true",
        dsPreferenceEndPoint: "/abs/perfpub/cnc/ucaservice/api/uca/customers/{customerId}/preferences/deliverySubscriptions",
        dsManageUrl: "/delivery-subscription/manage-delivery-subscription.html",
        dsUserApiEndpoint: "/abs/perfpub/subscription/api/user/{gid}",
        dsCancelReasonsApiEndpoint: "/abs/perfpub/subscription/api/admin/cancel/reasons",
        dsUserShopOrderCountApiEndpoint: "/abs/perfpub/web/ecom/api/subscription/user/ordercount",
        dsPaymentmethodDomain: "https://token-qa1.albertsons.com",
        dsJavaBasePath: "/abs/perfpub/erums/subscriptionservice",
        dsJavaEnabledFlag: "true",
        dsJavaServiceRestEndpoint: "/api/v1/subscription/plans",
        dsJavaUserApiEndpoint: "/api/v1/subscription/user/get/{gid}",
        dsJavaCancelReasonsApiEndpoint: "/api/v1/subscription/admin/cancel/reasons",
        dsJavaUserEnrollmentDetails: "/api/v1/subscription/user/getUserEnrollmentDetails",
        dsJavaSubscriptionReinstate: "/api/v1/subscription/user/reinstate/{gid}",
        dsJavaSubscriptionCreate: "/api/v1/subscription/user/create/{gid}",
        dsJavaGetUserTermsEndpoint: "/api/v1/subscription/user/terms/gid",
        dsConfirmationPagePath: "/freshpass/manage/confirmation",
        subscriptionHeaders: {
            deliverySubHttpJavaOptions: {
                'Accept': 'application/vnd.safeway.v2+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '2afdf86bd70247b680f7cbc21b82e4ac',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache'
            },
            deliverySubHttpJavaOptionsV3: {
              'Accept': 'application/vnd.safeway.v3+json',
              'banner': '{banner}',
              'ocp-apim-subscription-key': '2afdf86bd70247b680f7cbc21b82e4ac',
              'Content-Type': 'application/json',
              'x-swy-client-id': 'web-portal',
              'x-swy-client-name': 'WEB-PORTAL',
              'x-swy-banner': '{banner}',
              'cache-control': 'no-cache',
            },
            deliverySubHttpJavaOptionsV4: {
                'Accept': 'application/vnd.safeway.v4+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '2afdf86bd70247b680f7cbc21b82e4ac',
                'Content-Type': 'application/json',
                'cache-control': 'no-cache',
                'x-swy-client-name': 'web-portal',
                'x-swy-banner': '{banner}',
            },
            ucaHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'X-SWY_BANNER': '{banner}',
                'Ocp-Apim-Subscription-Key': '2da4442dd7fb43168a48531d63d27e0e',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            ucaHttpOptionsv4: {
              'Accept': 'application/vnd.safeway.v4+json',
              'x-swy-banner': '{banner}',
              'x-swy-client-name': 'web-portal',
              'Ocp-Apim-Subscription-Key': '2da4442dd7fb43168a48531d63d27e0e',
            },
            paymentOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '261c9c8ac0c347ea866eaa90a303b475',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-name': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            reinstateOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'X-SWY_BANNER': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': '2afdf86bd70247b680f7cbc21b82e4ac',
            }
        },
        offerGalleryFilterApiHeaders: {
            'Accept': 'application/json',
            'x-swy-client-id': 'web-portal',
            'Content-Type': 'application/json',
            'X-SWY_API_KEY': 'emjou',
            'x-swy_banner': '{banner}',
            'Cache-Control': 'no-cache',
            'X-SWY_VERSION': '3.0',
            'X-SWY-APPLICATION-TYPE': 'web',
            'emju-ocsp-b4u-perf': 'ca6fd3bf7c67453b9cf3cedc71050a0f'
        },
        partnerOffersAllocationApiHeaders: {
            'Content-Type': 'application/vnd.safeway.v1+json',
            'Cache-Control': 'no-cache',
            'X-SWY_VERSION': '3.0',
            'X-SWY-APPLICATION-TYPE': 'web',
            'banner': '{banner}',
            'Ocp-Apim-Subscription-Key': '',
            'x-swy-client-name': 'web-portal',
            'x-swy-banner': '{banner}',
         },
        freshpassFAQ: '/delivery-subscription/dsfaqs.html?isDSManage=true'
    },
    stage: {
        currentEnv: 'stage',
        aemFreshPassBenefitsJSONURL: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.caas.json',
        freshpassLPMaster_Jewelosco_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.caas.json',
        freshpassLPMaster_Acme_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.caas.json',
        getSubscriptionApiConfig: {
            url: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint,
        },
        getUserEnrollmentDetails: {
            url: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/getUserEnrollmentDetails/{uuid}/{gid}',
        },
        getPlansApiConfig: {
            url: "/abs/stgpub/erums/subscriptionservice/api/v1/subscription/plans",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaServiceRestEndpoint,
        },
        changePlanApiConfig: {
            url: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/create/{gid}',
        },
        getTendersApiConfig: {
            url: "/abs/stageint/ospg/tokenvault/wallet/customers/{uuid}/payment-methods?paymentMethodContext=FRESH_PASS&pageViewContext=DEFAULT_VIEW",
            // url: _window().AB.creditCardInfoTokenvaultPath.replace('{customerId}', _window().AB.userInfo.UUID) + '?storeId=9999',
        },

        getUserProfileInfo: {
            url: "/abs/stgpub/cnc/ucaservice/api/uca/customers/{gid}/profile"
            // url: _window().AB.COMMON.ucaAPIPathWithCustomerId(_window().AB.userProfilePath),
        },

        getCancelReasonsApiConfig: {
            url: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/admin/cancel/reasons',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaCancelReasonsApiEndpoint,
        },
        getCancelReasonsApiConfigV2: {
          url: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/cancel/reasons'
        },
        cancelSubscriptionPlanApiConfig: {
            url: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/cancel/{gid}'
            // url: (_window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint.replace('{gid}', _window().AB.userInfo.gid)).replace('get', 'cancel'),
        },

        getTermsInfoApi: {
            url: "/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/terms/gid",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaGetUserTermsEndpoint + '/'+ _window().AB.userInfo.customerId,
        },
        getPartnerDiscount: {
            url: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/getPartnerDiscount',
        },
        loyaltyPromosURL: "/bin/safeway/loyalty/promos",
        paymentIframeURL: 'https://token-stage.albertsons.com/api/v1/payment/',
        reinstateAPI: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/reinstate/',
        snapEligibilityEasySteps: '/content/experience-fragments/www/landing_pages/freshpass/fresh-pass-snap-eligibility/master.content.html',
        preChurnCancelBenefitsTiles: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/prechurn-benefits-tiles.caas.json',
        freshpassLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.content.html',
        freshpassLPMaster_Jewelosco: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.content.html',
        freshpassLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.content.html',
        belowTilesLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/master.content.html',
        belowTilesLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/below-tiles-jo-acme.content.html',
        belowTilesLpMaster_Jo: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/jo-below-tiles.content.html',
        freshpassContentFAQ: '/content/experience-fragments/www/landing_pages/delivery-subscription-faqs/delivery-subscription-faqs.content.html',
        freshpassTerms: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/delivery-subscription-terms-and-conditions.content.html',
        freshpassTerms_Acme: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/acme-terms-and-conditions.content.html',
        freshpassTerms_JO: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/jo-terms-and-conditions.content.html',
        createAccountFragment: '/content/experience-fragments/www/{banner}/en/generic_content/account/create-account.html',
        signInFragement: '/content/experience-fragments/www/{banner}/en/generic_content/account/sign-in.html',
        dsEnabledFlag: "true",
        dsPreferenceEndPoint: "/abs/stgpub/cnc/ucaservice/api/uca/customers/{customerId}/preferences/deliverySubscriptions",
        dsManageUrl: "/delivery-subscription/manage-delivery-subscription.html",
        dsUserApiEndpoint: "/abs/stgpub/subscription/api/user/{gid}",
        dsCancelReasonsApiEndpoint: "/abs/stgpub/subscription/api/admin/cancel/reasons",
        dsUserShopOrderCountApiEndpoint: "/abs/stgpub/web/ecom/api/subscription/user/ordercount",
        dsPaymentmethodDomain: "https://token-qa1.albertsons.com",
        dsJavaBasePath: "/abs/stgpub/erums/subscriptionservice",
        dsJavaEnabledFlag: "true",
        dsJavaServiceRestEndpoint: "/api/v1/subscription/plans",
        dsJavaUserApiEndpoint: "/api/v1/subscription/user/get/{gid}",
        dsJavaCancelReasonsApiEndpoint: "/api/v1/subscription/admin/cancel/reasons",
        dsJavaUserEnrollmentDetails: "/api/v1/subscription/user/getUserEnrollmentDetails",
        dsJavaSubscriptionReinstate: "/api/v1/subscription/user/reinstate/{gid}",
        dsJavaSubscriptionCreate: "/api/v1/subscription/user/create/{gid}",
        dsJavaGetUserTermsEndpoint: "/api/v1/subscription/user/terms/gid",
        dsConfirmationPagePath: "/freshpass/manage/confirmation",
        subscriptionHeaders: {
            deliverySubHttpJavaOptions: {
                'Accept': 'application/vnd.safeway.v2+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'd1d4174ce58d4c348f8e950a97ad4d49',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache'
            },
            deliverySubHttpJavaOptionsV3: {
              'Accept': 'application/vnd.safeway.v3+json',
              'banner': '{banner}',
              'ocp-apim-subscription-key': 'd1d4174ce58d4c348f8e950a97ad4d49',
              'Content-Type': 'application/json',
              'x-swy-client-id': 'web-portal',
              'x-swy-client-name': 'WEB-PORTAL',
              'x-swy-banner': '{banner}',
              'cache-control': 'no-cache',
            },
            deliverySubHttpJavaOptionsV4: {
                'Accept': 'application/vnd.safeway.v4+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'd1d4174ce58d4c348f8e950a97ad4d49',
                'Content-Type': 'application/json',
                'cache-control': 'no-cache',
                'x-swy-client-name': 'web-portal',
                'x-swy-banner': '{banner}',
            },
            ucaHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'X-SWY_BANNER': '{banner}',
                'Ocp-Apim-Subscription-Key': 'f3bbb1aaf7da473cb338a3dd8a1f59bd',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            ucaHttpOptionsv4: {
              'Accept': 'application/vnd.safeway.v4+json',
              'x-swy-banner': '{banner}',
              'x-swy-client-name': 'web-portal',
              'Ocp-Apim-Subscription-Key': 'f3bbb1aaf7da473cb338a3dd8a1f59bd',
            },
            paymentOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '38dc4fcede004d9e8ecdfe49f6c246c6',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-name': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            reinstateOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'X-SWY_BANNER': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': 'd1d4174ce58d4c348f8e950a97ad4d49',
            }
        },
        freshpassFAQ: '/delivery-subscription/dsfaqs.html?isDSManage=true'
    },
    prod: {
        currentEnv: 'prod',
        aemFreshPassBenefitsJSONURL: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.caas.json',
        freshpassLPMaster_Jewelosco_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.caas.json',
        freshpassLPMaster_Acme_CASS: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.caas.json',
        getSubscriptionApiConfig: {
            url: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint,
        },
        getUserEnrollmentDetails: {
            url: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/getUserEnrollmentDetails/{uuid}/{gid}',
        },
        getPlansApiConfig: {
            url: "/abs/pub/erums/subscriptionservice/api/v1/subscription/plans",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaServiceRestEndpoint,
        },
        changePlanApiConfig: {
            url: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/create/{gid}',
        },
        getTendersApiConfig: {
            url: "/abs/int/ospg/tokenvault/wallet/customers/{uuid}/payment-methods?paymentMethodContext=FRESH_PASS&pageViewContext=DEFAULT_VIEW",
            // url: _window().AB.creditCardInfoTokenvaultPath.replace('{customerId}', _window().AB.userInfo.UUID) + '?storeId=9999',
        },

        getUserProfileInfo: {
            url: "/abs/pub/cnc/ucaservice/api/uca/customers/{gid}/profile"
            // url: _window().AB.COMMON.ucaAPIPathWithCustomerId(_window().AB.userProfilePath),
        },

        getCancelReasonsApiConfig: {
            url: '/abs/pub/erums/subscriptionservice/api/v1/subscription/admin/cancel/reasons',
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaCancelReasonsApiEndpoint,
        },
        getCancelReasonsApiConfigV2: {
          url: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/cancel/reasons'
        },
        cancelSubscriptionPlanApiConfig: {
            url: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/cancel/{gid}'
            // url: (_window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaUserApiEndpoint.replace('{gid}', _window().AB.userInfo.gid)).replace('get', 'cancel'),
        },

        getTermsInfoApi: {
            url: "/abs/pub/erums/subscriptionservice/api/v1/subscription/user/terms/gid",
            // url: _window().SWY.CONFIGSERVICE.DSConfig.dsJavaBasePath + _window().SWY.CONFIGSERVICE.DSConfig.dsJavaGetUserTermsEndpoint + '/'+ _window().AB.userInfo.customerId,
        },
        getPartnerDiscount: {
            url: '/abs/pub/erums/subscriptionservice/api/v1/subscription/getPartnerDiscount',
        },
        getOffersGalleryFilterApi: {
          url: '/abs/pub/dce/offergallery/offers/filter',
        },
        loyaltyPromosURL: "/bin/safeway/loyalty/promos",
        paymentIframeURL: 'https://token.albertsons.com/api/v1/payment/',
        reinstateAPI: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/reinstate/',
        snapEligibilityEasySteps: '/content/experience-fragments/www/landing_pages/freshpass/fresh-pass-snap-eligibility/master.content.html',
        preChurnCancelBenefitsTiles: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/prechurn-benefits-tiles.caas.json',
        freshpassLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/master.content.html',
        freshpassLPMaster_Jewelosco: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-jo.content.html',
        freshpassLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/freshpass-tiles/freshpass-tiles-acme.content.html',
        belowTilesLpMaster: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/master.content.html',
        belowTilesLPMaster_Acme: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/below-tiles-jo-acme.content.html',
        belowTilesLpMaster_Jo: '/content/experience-fragments/www/landing_pages/freshpass/below-tiles/jo-below-tiles.content.html',
        freshpassContentFAQ: '/content/experience-fragments/www/landing_pages/delivery-subscription-faqs/delivery-subscription-faqs.content.html',
        freshpassTerms: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/delivery-subscription-terms-and-conditions.content.html',
        freshpassTerms_Acme: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/acme-terms-and-conditions.content.html',
        freshpassTerms_JO: '/content/experience-fragments/www/landing_pages/delivery-subscription-terms-and-conditions/jo-terms-and-conditions.content.html',
        createAccountFragment: '/content/experience-fragments/www/{banner}/en/generic_content/account/create-account.html',
        signInFragement: '/content/experience-fragments/www/{banner}/en/generic_content/account/sign-in.html',
        dsEnabledFlag: "true",
        dsPreferenceEndPoint: "/abs/pub/cnc/ucaservice/api/uca/customers/{customerId}/preferences/deliverySubscriptions",
        dsManageUrl: "/delivery-subscription/manage-delivery-subscription.html",
        dsUserApiEndpoint: "/abs/pub/subscription/api/user/{gid}",
        dsCancelReasonsApiEndpoint: "/abs/pub/subscription/api/admin/cancel/reasons",
        dsUserShopOrderCountApiEndpoint: "/abs/pub/web/ecom/api/subscription/user/ordercount",
        dsPaymentmethodDomain: "https://token-qa1.albertsons.com",
        dsJavaBasePath: "/abs/pub/erums/subscriptionservice",
        dsJavaEnabledFlag: "true",
        dsJavaServiceRestEndpoint: "/api/v1/subscription/plans",
        dsJavaUserApiEndpoint: "/api/v1/subscription/user/get/{gid}",
        dsJavaCancelReasonsApiEndpoint: "/api/v1/subscription/admin/cancel/reasons",
        dsJavaUserEnrollmentDetails: "/api/v1/subscription/user/getUserEnrollmentDetails",
        dsJavaSubscriptionReinstate: "/api/v1/subscription/user/reinstate/{gid}",
        dsJavaSubscriptionCreate: "/api/v1/subscription/user/create/{gid}",
        dsJavaGetUserTermsEndpoint: "/api/v1/subscription/user/terms/gid",
        dsConfirmationPagePath: "/freshpass/manage/confirmation",
        subscriptionHeaders: {
            deliverySubHttpJavaOptions: {
                'Accept': 'application/vnd.safeway.v2+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '5d70c90bff4f4853bc8cc8021267cf16',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache'
            },
            deliverySubHttpJavaOptionsV3: {
              'Accept': 'application/vnd.safeway.v3+json',
              'banner': '{banner}',
              'ocp-apim-subscription-key': '5d70c90bff4f4853bc8cc8021267cf16',
              'Content-Type': 'application/json',
              'x-swy-client-id': 'web-portal',
              'x-swy-client-name': 'WEB-PORTAL',
              'x-swy-banner': '{banner}',
              'cache-control': 'no-cache',
            },
            deliverySubHttpJavaOptionsV4: {
                'Accept': 'application/vnd.safeway.v4+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '5d70c90bff4f4853bc8cc8021267cf16',
                'Content-Type': 'application/json',
                'cache-control': 'no-cache',
                'x-swy-client-name': 'web-portal',
                'x-swy-banner': '{banner}',
            },
            ucaHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'X-SWY_BANNER': '{banner}',
                'Ocp-Apim-Subscription-Key': '1d8f9e6f8b0d4ce29468d6d82f5847b8',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            ucaHttpOptionsv4: {
              'Accept': 'application/vnd.safeway.v4+json',
              'x-swy-banner': '{banner}',
              'x-swy-client-name': 'web-portal',
              'Ocp-Apim-Subscription-Key': '1d8f9e6f8b0d4ce29468d6d82f5847b8',
            },
            paymentOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '0fa1435d95894cb08e5461e86cc666fb',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-name': 'web-portal',
                'Cache-Control': 'no-cache'
            },
            reinstateOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'X-SWY_BANNER': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': '5d70c90bff4f4853bc8cc8021267cf16',
            }
          },
          offerGalleryFilterApiHeaders: {
            'Accept': 'application/json',
            'x-swy-client-id': 'web-portal',
            'Content-Type': 'application/json',
            'X-SWY_API_KEY': 'emjou',
            'x-swy_banner': '{banner}',
            'Cache-Control': 'no-cache',
            'X-SWY_VERSION': '3.0',
            'X-SWY-APPLICATION-TYPE': 'web',
            'emju-ocsp-b4u-prod': 'ca6fd3bf7c67453b9cf3cedc71050a0f'
          },
          freshpassFAQ: '/delivery-subscription/dsfaqs.html?isDSManage=true'
    }
};
